import Hit from './Hit.wav'
import Miss from './Miss.wav'
const { Meta, Cali, MetaVision, MetaRandom, Randex } = require("./metaengine");

export const VT_Base = {
	Start : function(){
		const CM = window.Meta.get("ContrastMode");
		const fill = CM ? (CM == "WoB" ? "white" : "black") : "white";
		const buffer = 30;
		const icosize = 36;
		
		//~ const Trophy = Meta.Image(icosize, icosize, fill=="white" ? "/ico/base/trophyW.svg" : "/ico/base/trophyB.svg");
		//~ Trophy.Left = Meta.Stage.Left + buffer;
		//~ Trophy.Bot = Meta.Stage.Bot - buffer/2 - 5;
		
		const ScoreText = window.Meta.Text("Score", {fill, size:36});
		ScoreText.Left = window.Meta.Stage.Left + buffer + icosize + 7;
		ScoreText.Bot = window.Meta.Stage.Bot - buffer/2;
		
		window.Meta.set("VT_ScoreText", ScoreText);
	},
	StartTimer : function(dur){
		const CM = window.Meta.get("ContrastMode");
		const fill = CM ? (CM == "WoB" ? "white" : "black") : "white";
		const buffer = 30;
		const icosize = 36;
		var time = window.Meta.get("VT_Kountdown");
		//~ const Clock = Meta.Image(icosize, icosize, fill=="white" ? "/ico/base/clockW.svg" : "/ico/base/clockB.svg");
		//~ Clock.Right = Meta.Stage.Right - buffer - 95;
		//~ Clock.Bot = Meta.Stage.Bot - buffer/2 - 5;
		
		const TimeText = window.Meta.Text("", {fill, size:36});
		TimeText.Right = window.Meta.Stage.Right - buffer;
		TimeText.Bot = window.Meta.Stage.Bot - buffer/2;
		
		window.Meta.set("VT_Kountdown", dur * 60);
		window.Meta.set("VT_TimeText", TimeText);
		window.Meta.set("VT_KountdownPause", 1);
		// window.Meta.set("VT_Kountdown", time);
			
		var mins = Math.floor(dur);
		var secs = Math.floor(dur - mins) ;
		if (secs == 60){mins++; secs = 0;}
		window.Meta.get("VT_TimeText").Text = (mins>9? mins : "0" + mins) + ":" + (secs>9? secs : "0" + secs);
	},
	PauseTimer: function(){
		window.Meta.set("VT_KountdownPause", 1);
	},
	UnpauseTimer: function(){
		window.Meta.set("VT_KountdownPause", 0);
	},
	SetScore : function(s){
		window.Meta.get("VT_ScoreText").Text = s;
	},
	SetPrompt : function(s){
		window.Meta.get("VT_IntermissionText").Text = s;
		//~ if (s == ""){
			//~ Meta.get("VT_IntermissionPlaque").Hide();
		//~ }else{
			//~ Meta.get("VT_IntermissionPlaque").Show();
		//~ }
	},
	StartRounds : function(cnt){
		const CM = window.Meta.get("ContrastMode");
		const fill = CM ? (CM == "WoB" ? "white" : "black") : "white";
		const buffer = 30;
		const icosize = 36;
		
		const Laps = window.Meta.Image(icosize, icosize, fill=="white" ? "/ico/base/lapsW.svg" : "/ico/base/lapsB.svg");
		Laps.Right = window.Meta.Stage.Right - buffer - 95;
		Laps.Bot = window.Meta.Stage.Bot - buffer/2 - 5;
		
		const RoundText = window.Meta.Text("1/"+cnt, {fill, size:36});
		RoundText.Right = window.Meta.Stage.Right - buffer;
		RoundText.Bot = window.Meta.Stage.Bot - buffer/2;
		
		window.Meta.set("VT_CurrentRound", 1);
		window.Meta.set("VT_RoundTotal", cnt);
		window.Meta.set("VT_RoundText", RoundText);
	},
	NextRound : function(){
		const rnd = Meta.get("VT_CurrentRound") + 1;
		const tot = Meta.get("VT_RoundTotal");
		
		if (rnd > tot){
			const invoke = Meta.get("EndGame");
			if (invoke) invoke();
		}else{
			Meta.set("VT_CurrentRound", rnd);
			const txt = Meta.get("VT_RoundText");
			txt.Text = rnd + "/" + tot;
		}
	},
	InitIntermission : function(input="Accept"){
		const CM = Meta.get("ContrastMode");
		const fill = CM ? (CM == "WoB" ? "white" : "black") : "white";
		//~ const fill = CM ? (CM == "WoB" ? "white" : "black") : "white";
		//~ const txtFill = (fill == "white") ? "black" : "white";
		const buffer = 30;
		
		//~ const PWidth = 700;
		//~ const Plaque = Meta.Rect(PWidth, 61, {fill});
		//~ Plaque.Left = -PWidth/2;
		//~ Plaque.Bot = Meta.Stage.Bot - 12;
		//~ Plaque.Hide();
		
		const IntermissionText = Meta.Text("", {fill:fill, size:42});
		IntermissionText.Left = 0;
		IntermissionText.Right = 0;
		IntermissionText.Bot = Meta.Stage.Bot - buffer/2;
		
		const Callback = (E)=>{
			const curfoo = Meta.get("IsIntermission");
			if (curfoo){				
				Meta.get("VT_IntermissionText").Text = "";
				//~ Meta.get("VT_IntermissionPlaque").Hide();
				Meta.set("IsIntermission", null);
				Meta.get("UnpauseTimer")();
				curfoo();
			}
		};
		
		if (input == "Accept"){
			Meta.KeyDown("Accept", Callback);
			IntermissionText._trueText = "Press SPACEBAR to continue";
		}else if (input == "Click"){
			Meta.MouseClick("Left", Callback);
			IntermissionText._trueText = "Click anywhere to continue.";
		}
		
		Meta.set("VT_IntermissionText", IntermissionText);
		//~ Meta.set("VT_IntermissionPlaque", Plaque);
	},
	Intermission : function(foo){
		//~ Meta.get("VT_IntermissionPlaque").Show();
		const txt = Meta.get("VT_IntermissionText");
		txt.Text = txt._trueText;
		Meta.get("PauseTimer")();
		Meta.set("IsIntermission", foo);
	},
	Flipmission : function(foo){
		var txt = Meta.get("VT_FlipmissionText");
		if (!txt){
			const CM = Meta.get("ContrastMode");
			const fill = CM ? (CM == "WoB" ? "white" : "black") : "white";
			
			const FlipmissionText = Meta.Text("FLIP!", {fill:fill, size:75});
			FlipmissionText.Left = 0;
			FlipmissionText.Right = 0;
			FlipmissionText.Top = -21;
			
			txt = FlipmissionText;
			Meta.set("VT_FlipmissionText", FlipmissionText);
			
			Meta.Redraw();
		}
		
		txt.Show();
		Meta.get("PauseTimer")();
		Meta.set("IsIntermission", true);
		Meta.DoAfter(1000, ()=>{
			txt.Hide();
			Meta.get("UnpauseTimer")();
			Meta.set("IsIntermission", null);
			if (foo) foo();
		})
	},
	Tick : function(dT){
		var time = window.Meta.get("VT_Kountdown");
		if (time && !window.Meta.get("VT_KountdownPause")){
			time -= dT;
			window.Meta.set("VT_Kountdown", time);
			
			var mins = Math.floor(time/60);
			var secs = Math.floor(time - mins*60) + 1;
			if (secs == 60){mins++; secs = 0;}
			window.Meta.get("VT_TimeText").Text = (mins>9? mins : "0" + mins) + ":" + (secs>9? secs : "0" + secs);
			
			if (time <= 0){
				const invoke = window.Meta.get("EndGame");
				if (invoke) invoke();
			}
		}
	},
	StdSounds : function(){
		const ret = {
			_hit : window.Meta.Sound(Hit, 0.25),
			_miss : window.Meta.Sound(Miss, 0.25),
			Hit : function(){
				this._hit.Play();
			},
			Miss : function(){
				this._miss.Play();
			},
		}
		return ret;
	},
};

export const PlayerCursor = {
	Start : function(){
		window.Meta.Cursor(0);
		window.Meta.MouseMove(()=>{
			window.Meta.Cursor(1);
			window.Meta.set("CursorKountdown", 2);
		});
	},
	Tick : function(dT){
		var time = window.Meta.get("CursorKountdown");
		if (time && time > 0){
			time -= dT;
			window.Meta.set("CursorKountdown", time);
			
			if (time <= 0){
				window.Meta.Cursor(0);
			}
		}
	},
}

export const ColliderWrapper = {
	CircleWrap : function(rad, obj){
		const ret = {
			ctype : "C",
			obj,
			rad,
			RandomInBox : function(Left, Top, Right, Bot){
				this.Left = MetaRandom.Range(Left, Right - this.rad*2);
				this.Top = MetaRandom.Range(Top, Bot - this.rad*2);
			}
		}
		
		Object.defineProperty(ret, "Top", {
			get : function () {
				return this.obj.Top;
			},
			set : function (val) {
				this.obj.Top = val;
			},
		});
		
		Object.defineProperty(ret, "Bot", {
			get : function () {
				return this.obj.Bot;
			},
			set : function (val) {
				this.obj.Bot = val;
			},
		});
		
		Object.defineProperty(ret, "Left", {
			get : function () {
				return this.obj.Left;
			},
			set : function (val) {
				this.obj.Left = val;
			},
		});
		
		Object.defineProperty(ret, "Right", {
			get : function () {
				return this.obj.Right;
			},
			set : function (val) {
				this.obj.Right = val;
			},
		});
		
		Object.defineProperty(ret, "Rad", {
			get : function () {
				return this.rad;
			},
			set : function (val) {
				this.rad = val;
				this.obj.Width = val * 2;
				this.obj.Height = val * 2;
			},
		});
		
		ret.Rad = rad;
		return ret;
	}
}

export const ColliderShuffler = {
	SpiralDisperse : function(carr, Left, Top, Right, Bot){
		function Spiral(subarr, Left, Top, Right, Bot){
			const Quads = [[], [], [], []];
			const totlen = subarr.length;
			
			if (subarr.length <= 1){
				if(subarr.length == 1){
					subarr[0].RandomInBox(Left, Top, Right, Bot);
				}
			}else{
				const rs = MetaRandom.Dex(4);
				for(var c = 0; c < totlen; c++){
					Quads[(c+rs)%4].push(subarr.splice(MetaRandom.Dex(subarr.length), 1)[0]);
				}
				
				const HalfHorz = (Left+Right)/2;
				const HalfVert = (Top+Bot)/2;
				Spiral(Quads[0], Left, Top, HalfHorz, HalfVert);
				Spiral(Quads[1], HalfHorz, Top, Right, HalfVert);
				Spiral(Quads[2], HalfHorz, HalfVert, Right, Bot);
				Spiral(Quads[3], Left, HalfVert, HalfHorz, Bot);
			}
		}
		
		Spiral([...carr], Left, Top, Right, Bot);
	},
}

export const TumblingEKreator = {
	KreateE : function(c=true){
		const E = window.Meta.Path(0, 0, {fill: "#000000"});
		E.Crowd = c ? true : false;
		
		Object.defineProperty(E, "Size", {
			get : function() {
				return this._trueSize;
			},
			set : function(s) {
				this._trueSize = s;
				
				this.CLEAR();
				
				if (s > 0){
					if (s < 5){
						this.fits = false;
						this.MOVE(0,0);
						this.LINE(0, 5);
						this.LINE(5, 5);
						this.LINE(5, 0);
						this.LINE(0, 0);
						this.Width = 5;
						this.Height = 5;
					}else{
						this.fits = true;
						
						const fifth = Math.floor(s/5);
						const half = fifth * 2;
						const bar = fifth * 3;
						const subwhole = fifth * 4;
						const whole = fifth * 5;
						const fudge = Math.round(fifth/2);
						
						if (this.Crowd){
							this.MOVE(subwhole, 0);
							this.LINE(subwhole + bar, 0);
							this.LINE(subwhole + bar, fifth);
							this.LINE(subwhole, fifth);
							this.LINE(subwhole, 0);
							
							this.MOVE(0, subwhole);
							this.LINE(fifth, subwhole);
							this.LINE(fifth, subwhole + bar);
							this.LINE(0, subwhole + bar);
							this.LINE(0, subwhole);
							
							const Shift10 = whole + whole;
							
							this.MOVE(subwhole, Shift10);
							this.LINE(subwhole + bar, Shift10);
							this.LINE(subwhole + bar, Shift10+fifth);
							this.LINE(subwhole, Shift10+fifth);
							this.LINE(subwhole, Shift10);
							
							this.MOVE(Shift10, subwhole);
							this.LINE(Shift10+fifth, subwhole);
							this.LINE(Shift10+fifth, bar + subwhole);
							this.LINE(Shift10, bar + subwhole);
							this.LINE(Shift10, subwhole);
							
							this.MOVE(bar, bar);
							this.LINE(fifth+bar, bar);
							this.LINE(fifth+bar, subwhole+bar);
							this.LINE(half+bar, subwhole+bar);
							this.LINE(half+bar, bar);
							this.LINE(bar+bar, bar);
							this.LINE(bar+bar, subwhole+bar);
							this.LINE(subwhole+bar, subwhole+bar);
							this.LINE(subwhole+bar, bar);
							this.LINE(whole+bar, bar);
							this.LINE(whole+bar, whole+bar);
							this.LINE(bar, whole+bar);
							this.LINE(bar, bar);
							
							this.Width = 2*whole + fifth;
							this.Height = 2*whole + fifth;
						}else{
							this.MOVE(0, 0);
							this.LINE(fifth, 0);
							this.LINE(fifth, subwhole);
							this.LINE(half, subwhole);
							this.LINE(half, 0);
							this.LINE(bar, 0);
							this.LINE(bar, subwhole);
							this.LINE(subwhole, subwhole);
							this.LINE(subwhole, 0);
							this.LINE(whole, 0);
							this.LINE(whole, whole);
							this.LINE(0, whole);
							this.LINE(0, 0);
							
							this.Width = whole;
							this.Height = whole;
						}
					}
					this.DRAW();
				}
			},
		});
		
		return E;
	}
}

export const GridKreator = {
	KreateGrid : function(x, y, dim, config={line:"#ffffff", stroke:2}){
		const strokeHalf = config.stroke/2;
		const dimX = dim * x + strokeHalf*2;
		const dimY = dim * y + strokeHalf*2;
		const GridBoard = Meta.Path(dimX, dimY, config);
		
		for (var b = 0; b <= x; b++){
			GridBoard.MOVE(strokeHalf + dim*b, 0);
			GridBoard.LINE(strokeHalf + dim*b, dimY);
		}
		for (var b = 0; b <= y; b++){
			GridBoard.MOVE(0, strokeHalf + dim*b);
			GridBoard.LINE(dimX, strokeHalf + dim*b);
		}
		GridBoard.DRAW();
		
		GridBoard.DimX = dimX;
		GridBoard.DimY = dimY;
		
		return GridBoard;
	}
}

export const RandomGridMaker = {
	NewRandomGrid : function(dim){
		const size = 30;
		const HalfStroke = 1;
		const border = 5;
		
		const GridBack = Meta.Rect(size * dim + border*2 + HalfStroke*2, size * dim + border*2 + HalfStroke*2, {fill:"#ffffff"});
		const GridOn = Meta.Path(size * dim + HalfStroke*2, size * dim + HalfStroke*2, {fill:"#ffffff",line:"#000000", stroke:HalfStroke*2});
		GridOn.Top = 0;
		const GridOff = Meta.Path(size * dim + HalfStroke*2, size * dim + HalfStroke*2, {fill:"#000000",line:"#000000", stroke:HalfStroke*2});
		GridOff.Top = 0;
		
		const ret = {_dim:dim, _size:size, _hs: HalfStroke, _bor:border, back:GridBack, on:GridOn, off:GridOff, _data:[], 
			Shuffle:function(p=null, sim=0, FNS=false){
				if (p){
					const gtx = MetaRandom.Dex(p.length);
					for(var x = 0; x < p.length; x++){
						if (x == gtx){
							this._data[x] = p[x] ? 0 : 1;
						}else{
							this._data[x] = MetaRandom.Range(0, 1) > sim ? MetaRandom.Dex(2) : p[x];
						}
					}
				}else{
					this._data = [];
					for (var c = 0; c < this._dim * this._dim; c++){
						this._data.push(MetaRandom.Dex(2));
					}
				}
				
				var cert = false;
				if (FNS){
					for (var d = 0; d < (this._dim * this._dim)/2; d++){
						if(this._data[d] != this._data[this._dim * this._dim - 1 - d]){
							cert = true;
							break;
						}
					}
				}else{
					cert = true;
				}
				
				if (cert){
					this.Draw();
				}else{
					this.Shuffle(p, sim, FNS);
				}
			},
			Draw:function(){
				this.on.CLEAR();
				this.off.CLEAR();
				
				for (var x = 0; x < this._dim; x++){
					for (var y = 0; y < this._dim; y++){
						var Grid = this._data[x + y*this._dim] == 0 ? this.on : this.off;
						Grid.MOVE(x*this._size + this._hs,y*this._size + this._hs);
						Grid.LINE(x*this._size + this._hs,(y+1)*this._size + this._hs);
						Grid.LINE((x+1)*this._size + this._hs,(y+1)*this._size + this._hs);
						Grid.LINE((x+1)*this._size + this._hs,y*this._size + this._hs);
						Grid.LINE(x*this._size + this._hs,y*this._size + this._hs);
					}
				}
				this.on.DRAW();
				this.off.DRAW();
			}
		};
		
		ret.Shuffle();
		
		Object.defineProperty(ret, "Pattern", {
			get : function() {
				return this._data;
			},
			set : function(P) {
				this._data = P;
				this.Draw();
			},
		});
		
		Object.defineProperty(ret, "Top", {
			get : function() {
				return this.back.Top;
			},
			set : function(t) {
				this.back.Top = t;
				this.on.Top = t + this._bor;
				this.off.Top = t + this._bor;
			},
		});
		
		Object.defineProperty(ret, "Left", {
			get : function() {
				return this.back.Left;
			},
			set : function(t) {
				this.back.Left = t;
				this.on.Left = t + this._bor;
				this.off.Left = t + this._bor;
			},
		});
		
		Object.defineProperty(ret, "Right", {
			get : function() {
				return this.back.Right;
			},
			set : function(t) {
				this.back.Right = t;
				this.on.Right = t - this._bor;
				this.off.Right = t - this._bor;
			},
		});
		
		Object.defineProperty(ret, "Width", {
			get : function() {
				return this.back.Width;
			},
		});
		
		Object.defineProperty(ret, "Height", {
			get : function() {
				return this.back.Height;
			},
		});
		
		Object.defineProperty(ret, "Dim", {
			set : function(dim) {
				this.back.Width = dim;
				this.back.Height = dim;
				this.on.Width = dim - this._bor*2;
				this.on.Height = dim - this._bor*2;
				this.off.Width = dim - this._bor*2;
				this.off.Height = dim - this._bor*2;
				
				this._size = (dim - this._hs*2 - this._bor*2) / this._dim;
				this.Draw();
			},
		});
		
		Object.defineProperty(ret, "Rotation", {
			get : function() {
				return this.back.Rotation;
			},
			set : function(r) {
				this.back.Rotation = r;
				this.on.Rotation = r;
				this.off.Rotation = r;
			},
		});
		
		const ClickWrapper = function(){
			this.p._click.call(this.p);
		}
		
		Object.defineProperty(ret, "onclick", {
			set : function(foo) {
				this._click = foo;
				this.back.onclick = ClickWrapper;
				this.on.onclick = ClickWrapper;
				this.off.onclick = ClickWrapper;
				this.back.p = this;
				this.on.p = this;
				this.off.p = this;
			},
		});
		
		ret.Show = function(){
			this.back.Show();
			this.on.Show();
			this.off.Show();
		}
		
		ret.Hide = function(){
			this.back.Hide();
			this.on.Hide();
			this.off.Hide();
		}
		
		return ret;
	}
};

export const GaborKreator = {
	KreateGabor : function(dim=400, wl=50, std=50, cntr=1){
		const gabor = Meta.Canvas(dim, dim, function(){
			//~ const Contrasts = [0, 74, 127, 163, 191, 210, 223, 232, 239, 244, 247, 249, 250, 252, 253, 254];
			const Contrasts = [0, 0.291, 0.5, 0.64, 0.749, 0.822, 0.874, 0.911, 0.937, 0.955, 0.968, 0.978, 0.984, 0.989, 0.992, 0.994];
			for (var x=0; x<this.Width; x++) {
				for (var y=0; y<this.Height; y++) {
					const cos = (Math.cos((x-dim/2+this.Shift)/this.Wavelength * 2 * Math.PI) / 2 + 0.5);
					const amp = (cos + Contrasts[this.Hamdex-1]* (1-cos)) * 255;
					const guass = Math.exp(-0.5 * Math.pow((x-this.Width/2) / this.StdDev, 2.0) - 0.5 * Math.pow((y-this.Height/2) / this.StdDev, 2.0)) * 255;
					this.SetPixel(x, y, amp, amp, amp, guass);
				}
			}
		});
		gabor.Wavelength = wl;
		gabor.StdDev = std;
		gabor.Shift = 0;
		gabor.Hamdex = cntr;
		return gabor;
	}
}

export const RdsKreator = {
	RdsKreator : function(dim=500, ps=5){
		function DrawFunc(){
			for (var x=0; x<this.Width; x++) {
				for (var y=0; y<this.Height; y++) {
					const pix = this.rds.PixSize;
					const n = Math.floor(y/pix) * this.Width/pix + Math.floor(x/pix);
					if (this.col == "red"){
						//~ this.SetPixel(x, y, 255, 0, 0, this.noise[n]?0:255);
						this.SetPixel(x, y, 255, 0, 0, this.noise?0:255);
						//~ this.SetPixel(x, y, 255, 0, 0, MetaRandom.Dex(2)==0?0:255);
					}else{
						//~ this.SetPixel(x, y, 0, 0, 255, this.noise[n]?0:255);
						this.SetPixel(x, y, 0, 0, 255, this.noise?0:255);
						//~ this.SetPixel(x, y, 0, 0, 255, MetaRandom.Dex(2)==0?0:255);
					}
				}
			}
		}
		
		const rds = Meta.Anchor();
		rds.DIM = dim;
		rds.PixSize = ps;
		const red = Meta.Canvas(dim, dim, DrawFunc);
		red.Left = 0;
		red.Top = 0;
		red.Blend = "Add";
		red.col = "red";
		const blue = Meta.Canvas(dim, dim, DrawFunc);
		blue.Left = 0;
		blue.Top = 0;
		blue.Blend = "Add";
		blue.col = "blue";
		
		red.Parent = rds;
		blue.Parent = rds;
		rds.red = red;
		rds.blue = blue;
		red.rds = rds;
		blue.rds = rds;
		
		rds.SepX = function(sep){
			this.red.Left = -sep/2;
			this.blue.Left = sep/2;
		}
		
		rds.noise = 0;
		rds.Renoise = function(){
			this.noise++;
			this.red.noise = this.noise%2==0;
			this.blue.noise = this.noise%2==0;
			this.red.Redraw();
			this.blue.Redraw();
		}
		rds.Renoise();
		return rds;
	}
}

export const Trackerz = {
	NewTracker : function(){
		const ret = {
			hit : 0,
			miss : 0,
			Hit : function(){
				this.hit++;
			},
			Miss : function(){
				this.miss++;
			}
		};
		
		Object.defineProperty(ret, "Perc", {
			get : function () {
				return this.hit + "/" + this.tot;
			},
		});
		
		Object.defineProperty(ret, "Val", {
			get : function () {
				return [this.hit, this.miss];
			},
		});
		
		Object.defineProperty(ret, "Str", {
			get : function () {
				return this.hit + "/" + (this.hit + this.miss);
			},
		});
		
		return ret;
	},
	NewAX : function(){
		const ret = {
			total: 0,
			count: 0,
			Acc: function(val){
				this.total += val;
				this.count++;
			},
		};
		
		Object.defineProperty(ret, "Val", {
			get : function () {
				return this.count ? this.total / this.count : 0;
			},
		});
		
		return ret;
	},
	ReaktTimer : -1,
	ReaktMark : function(){
		const time = window.Meta.get("ReaktTimer");
		window.Meta.set("ReaktTimer", 0);
		
		if (time < 0){
			return null;
		}
		return time;
	},
	Tick : function(dT){
		const curTime = window.Meta.get("ReaktTimer");
		
		if (curTime >= 0){
			window.Meta.set("ReaktTimer", curTime + dT);
		}
	},
}

export const ImageBankz = {
	ImageBankz: {
		Ansel: [
			"L1.jpg", "L2.jpg", "L3.jpg", "L4.jpg", "L5.jpg", "L6.jpg", "L7.jpg", "L8.jpg", "L9.jpg", "L10.jpg",
		],
		animals: [
			"Bat.png", "Bear.png", "Crocodile.png", "Deer.png", "Dolphin.png", "Eagle.png", "Elephant.png",
			"Fox.png", "Frog.png", "Giraffe.png", "Gorilla.png", "Hedgehog.png", "Hippopotamus.png", "Kangaroo.png",
			"Leopard.png", "Lion.png", "Octopus.png", "Owl.png", "Penguin.png", "Raccoon.png", "Rhino.png", "Seahorse.png",
			"Seal.png", "Shark.png", "Squirrel.png", "Tiger.png", "Whale.png", "Wolf.png", "Zebra.png",
		],
		food: [
			"Hotdog.png", "Burger.png", "Chicken.png", "Chocolate.png", "Cupcake.png", "Donut.png", "Fish.png", "Fries.png", "Ice Cream.png", 
			"Ketchup.png", "Lemonade.png", "Mustard.png", "Pizza.png", "Ramen.png", "Sandwich.png", "Soda.png", "Sushi.png", "Taco.png"
		],
	},
	RandomFromBank : function(bank, count=1){
		const ret = [];
		const rolls = [];
		const Bank = Meta.get("ImageBankz")[bank];
		
		for (var x = 0; x < count; x++){
			var dex = MetaRandom.Dex(Bank.length);
			while (rolls.includes(dex)){
				dex = MetaRandom.Dex(Bank.length);
			}
			rolls.push(dex);
			const key = Bank[dex];
			ret.push({name:key.split(".")[0], path:"/img/banks/" + bank + "/" + key});
		}
		return ret.length == 1 ? ret[0] : ret;
	},
};

export const RandomPicturez = window.Meta.Engine(ImageBankz, RandomGridMaker, {
	RandomPicturez : function(type, paras={}){
		const ret = {
			type,
			paras,
			_keys : {
				"Food" : "food",
				"Animals" : "animals",
				"Photos" : "Ansel",
			},
			RandomFind : function(aCnt, cnts){
				if (this.type == "Patterns"){
					aCnt.Shuffle();
					const adex = MetaRandom.Dex(cnts.length);
					aCnt._A = adex;
					
					for (var x = 0; x < cnts.length; x++){
						if (x == adex){
							cnts[x].Pattern = aCnt.Pattern;
						}else{
							cnts[x].Shuffle(aCnt.Pattern, this.paras.gsim/10);
						}
						cnts[x]._A = x;
					}
				}else{
					const RandomImage = Meta.get("RandomFromBank");
					const imgs = RandomImage(this._keys[this.type], cnts.length);
					
					aCnt.Url = imgs[MetaRandom.Dex(cnts.length)].path;
					for (var x = 0; x < cnts.length; x++){
						cnts[x].Url = imgs[x].path;
					}
				}
			},
			RandomPairs : function(cnts){
				if (this.type == "Patterns"){
					const slots = [];
					for (var x = 0; x < cnts.length; x++){
						slots.push(x);
					}
					
					const As = [];
					for (var x = 0; x < cnts.length/2; x++){
						As.push(slots.splice(MetaRandom.Dex(slots.length), 1)[0]);
					}
					
					function CheckDupes(){
						var Cert = 0;
						var total = 0;
						for(var f = 0; f < As.length; f++){
							for (var p = f+1; p < As.length; p++){
								total++;
								for (var b = 0; b < cnts[0].Pattern.length; b++){
									if (cnts[As[f]].Pattern[b] != cnts[As[p]].Pattern[b]){
										Cert++;
										break;
									}
								}
							}
						}
						if (total > Cert){
							return true;
						}else{
							return false;
						}
					}
					
					do{
						for (var a = 0; a < As.length; a++){
							cnts[As[a]].Shuffle();
							cnts[As[a]]._A = a;
							cnts[slots[a]].Pattern = cnts[As[a]].Pattern;
							cnts[slots[a]]._A = a;
						}
					}while(CheckDupes());
				}else{
					const slots = [];
					for (var x = 0; x < cnts.length/2; x++){
						slots.push(x);
						slots.push(x);
					}
				
					const RandomImage = Meta.get("RandomFromBank");
					const imgs = RandomImage(this._keys[this.type], cnts.length/2);
					
					for (var x = 0; x < cnts.length; x++){
						const path = imgs[slots.splice(MetaRandom.Dex(slots.length), 1)[0]].path;
						cnts[x].Url = path;
					}
				}
			},
			RandomDiff : function(cnts){
				if (this.type == "Patterns"){
					cnts[0].Shuffle();
					cnts[0].A = false;
					const Pattern = cnts[0].Pattern;
					let Answer = MetaRandom.Dex(cnts.length);
					
					for (var p = 1; p < cnts.length; p++){
						cnts[p].Pattern = Pattern;
						cnts[p].A = false;
					}
					
					cnts[Answer].A = true;
					cnts[Answer].Shuffle(cnts[(Answer+1)%cnts.length].Pattern, this.paras.gsim/10);
				}else{
					const RandomImage = Meta.get("RandomFromBank");
					const imgs = RandomImage(this._keys[this.type], 2);
					
					let Answer = MetaRandom.Dex(cnts.length);
					
					for (var x = 0; x < cnts.length; x++){
						if (x == Answer){
							cnts[x].Url = imgs[0].path;
							cnts[x].A = true;
						}else{
							cnts[x].Url = imgs[1].path;
							cnts[x].A = false;
						}
					}
				}
			},
			RandomSingle : function(cnts){
				if (this.type == "Patterns"){
					cnts[0].Shuffle(null, 0, true);
					
					for (var p = 1; p < cnts.length; p++){
						cnts[p].Pattern = cnts[0].Pattern;
					}
				}else{
					const RandomImage = Meta.get("RandomFromBank");
					const img = RandomImage(this._keys[this.type]);
					
					for (var x = 0; x < cnts.length; x++){
						cnts[x].Url = img.path;
					}
				}
			},
			Container : function(dim){
				if (this.type == "Patterns"){
					const grid = Meta.get("NewRandomGrid")(this.paras.gdim);
					grid.Dim = dim;
					
					return grid;
				}else{
					const img = Meta.Image(dim, dim, "");
					
					Object.defineProperty(img, "Dim", {
						set : function(val) {
							this.Width = val;
							this.Height = val;
						},
					});
					
					return img;
				}
			},
			Matches : function(A, B){
				if (this.type == "Patterns"){
					return A._A == B._A;
				}else{
					return A.Url == B.Url;
				}
			},
			Copy : function(A, B){
				if (this.type == "Patterns"){
					B.Pattern = A.Pattern;
				}else{
					B.Url = A.Url;
				}
			},
		}
		
		return ret;
	},
});

export const WordBankz = {
	WordBankz: {
		Level: [
			["the", "of", "and", "a", "to", "in", "is", "you", "that", "it", "he", "was", "for", "on", "are", "as", "with", "his", "they", "I", "at", "be", "this", "have", "from", "or", "one", "had", "by", "words", "but", "not", "what", "all", "were", "we", "when", "your", "can", "said", "there", "use", "an", "each", "which", "she", "do", "how", "their", "if", "will", "up", "other", "about", "out", "many", "then", "them", "these", "so", "some", "her", "would", "make", "like", "him", "into", "time", "has", "look", "two", "more", "write", "go", "see", "number", "no", "way", "could", "people", "my", "than", "first", "water", "been", "called", "who", "am", "its", "now", "find", "long", "down", "day", "did", "get", "come", "made", "may", "part"],
			["over", "new", "sound", "take", "only", "little", "work", "know", "place", "years", "live", "me", "back", "give", "most", "very", "after", "things", "our", "just", "name", "good", "sentence", "man", "think", "say", "great", "where", "help", "through", "much", "before", "line", "right", "too", "means", "old", "any", "same", "tell", "boy", "follow", "came", "want", "show", "also", "around", "form", "three", "small", "set", "put", "end", "does", "another", "well", "large", "must", "big", "even", "such", "because", "turn", "here", "why", "ask", "went", "men", "read", "need", "land", "different", "home", "us", "move", "try", "kind", "hand", "picture", "again", "change", "off", "play", "spell", "air", "away", "animal", "house", "point", "page", "letter", "mother", "answer", "found", "study", "still", "learn", "should", "America", "world"],
			["high", "every", "near", "add", "food", "between", "own", "below", "country", "plant", "last", "school", "father", "keep", "tree", "never", "start", "city", "earth", "eyes", "light", "thought", "head", "under", "story", "saw", "left", "don't", "few", "while", "along", "might", "close", "something", "seem", "next", "hard", "open", "example", "begin", "life", "always", "those", "both", "paper", "together", "got", "group", "often", "run", "important", "until", "children", "side", "feet", "car", "mile", "night", "walk", "white", "sea", "began", "grow", "took", "river", "four", "carry", "state", "once", "book", "hear", "stop", "without", "second", "late", "miss", "idea", "enough", "eat", "face", "watch", "far", "Indian", "real", "almost", "let", "above", "girl", "sometimes", "mountains", "cut", "young", "talk", "soon", "list", "song", "being", "leave", "family", "it's"],
			["body", "music", "color", "stand", "sun", "questions", "fish", "area", "mark", "dog", "horse", "birds", "problem", "complete", "room", "knew", "since", "ever", "piece", "told", "usually", "didn't", "friends", "easy", "heard", "order", "red", "door", "sure", "become", "top", "ship", "across", "today", "during", "short", "better", "best", "however", "low", "hours", "black", "products", "happened", "whole", "measure", "remember", "early", "waves", "reached", "listen", "wind", "rock", "space", "covered", "fast", "several", "hold", "himself", "toward", "five", "step", "morning", "passed", "vowel", "true", "hundred", "against", "pattern", "numeral", "table", "north", "slowly", "money", "map", "farm", "pulled", "draw", "voice", "seen", "cold", "cried", "plan", "notice", "south", "sing", "war", "ground", "fall", "king", "town", "I'll", "unit", "figure", "certain", "field", "travel", "wood", "fire", "upon"],
			["done", "English", "road", "half", "ten", "fly", "gave", "box", "finally", "wait", "correct", "oh", "quickly", "person", "became", "shown", "minutes", "strong", "verb", "stars", "front", "feel", "fact", "inches", "street", "decided", "contain", "course", "surface", "produce", "building", "ocean", "class", "note", "nothing", "rest", "carefully", "scientists", "inside", "wheels", "stay", "green", "known", "island", "week", "less", "machine", "base", "ago", "stood", "plane", "system", "behind", "ran", "round", "boat", "game", "force", "brought", "understand", "warm", "common", "bring", "explain", "dry", "though", "language", "shape", "deep", "thousands", "yes", "clear", "equation", "yet", "government", "filled", "heat", "full", "hot", "check", "object", "am", "rule", "among", "noun", "power", "cannot", "able", "six", "size", "dark", "ball", "material", "special", "heavy", "fine", "pair", "circle", "include", "built"],
			["can't", "matter", "square", "syllables", "perhaps", "bill", "felt", "suddenly", "test", "direction", "center", "farmers", "ready", "anything", "divided", "general", "energy", "subject", "Europe", "moon", "region", "return", "believe", "dance", "members", "picked", "simple", "cells", "paint", "mind", "love", "cause", "rain", "exercise", "eggs", "train", "blue", "wish", "drop", "developed", "window", "difference", "distance", "heart", "site", "sum", "summer", "wall", "forest", "probably", "legs", "sat", "main", "winter", "wide", "written", "length", "reason", "kept", "interest", "arms", "brother", "race", "present", "beautiful", "store", "job", "edge", "past", "sign", "record", "finished", "discovered", "wild", "happy", "beside", "gone", "sky", "grass", "million", "west", "lay", "weather", "root", "instruments", "meet", "third", "months", "paragraph", "raised", "represent", "soft", "whether", "clothes", "flowers", "shall", "teacher", "held", "describe", "drive"],
			["cross", "speak", "solve", "appear", "metal", "son", "either", "ice", "sleep", "village", "factors", "result", "jumped", "snow", "ride", "care", "floor", "hill", "pushed", "baby", "buy", "century", "outside", "everything", "tall", "already", "instead", "phrase", "soil", "bed", "copy", "free", "hope", "spring", "case", "laughed", "nation", "quite", "type", "themselves", "temperature", "bright", "lead", "everyone", "method", "section", "lake", "iron", "within", "dictionary", "hair", "age", "amount", "scale", "pounds", "although", "per", "broken", "moment", "tiny", "possible", "gold", "milk", "quiet", "natural", "lot", "stone", "act", "build", "middle", "speed", "count", "consonant", "someone", "sail", "rolled", "bear", "wonder", "smiled", "angle", "fraction", "Africa", "killed", "melody", "bottom", "trip", "hole", "poor", "let's", "fight", "surprise", "French", "died", "beat", "exactly", "remain", "dress", "cat", "couldn't", "fingers"],
			["row", "least", "catch", "climbed", "wrote", "shouted", "continued", "itself", "else", "plains", "gas", "England", "burning", "design", "joined", "foot", "law", "ears", "glass", "you're", "grew", "skin", "valley", "cents", "keypresident", "brown", "trouble", "cool", "cloud", "lost", "sent", "symbols", "wear", "bad", "save", "experiment", "engine", "alone", "drawing", "east", "choose", "single", "touch", "information", "express", "mouth", "yard", "equal", "decimal", "yourself", "control", "practice", "report", "straight", "rise", "statement", "stick", "party", "seeds", "suppose", "woman", "coast", "bank", "period", "wire", "pay", "clean", "visit", "bit", "whose", "received", "garden", "please", "strange", "caught", "fell", "team", "God", "captain", "direct", "ring", "serve", "child", "desert", "increase", "history", "cost", "maybe", "business", "separate", "break", "uncle", "hunting", "flow", "lady", "students", "human", "art", "feeling"],
			["supply", "corner", "electric", "insects", "crops", "tone", "hit", "sand", "doctor", "provide", "thus", "won't", "cook", "bones", "mall", "board", "modern", "compound", "mine", "wasn't", "fit", "addition", "belong", "safe", "soldiers", "guess", "silent", "trade", "rather", "compare", "crowd", "poem", "enjoy", "elements", "indicate", "except", "expect", "flat", "seven", "interesting", "sense", "string", "blow", "famous", "value", "wings", "movement", "pole", "exciting", "branches", "thick", "blood", "lie", "spot", "bell", "fun", "loud", "consider", "suggested", "thin", "position", "entered", "fruit", "tied", "rich", "dollars", "send", "sight", "chief", "Japanese", "stream", "planets", "rhythm", "eight", "science", "major", "observe", "tube", "necessary", "weight", "meat", "lifted", "process", "army", "hat", "property", "particular", "swim", "terms", "current", "park", "sell", "shoulder", "industry", "wash", "block", "spread", "cattle", "wife", "sharp"],
			["company", "radio", "we'll", "action", "capital", "factories", "settled", "yellow", "isn't", "southern", "truck", "fair", "printed", "wouldn't", "ahead", "chance", "born", "level", "triangle", "molecules", "France", "repeated", "column", "western", "church", "sister", "oxygen", "plural", "various", "agreed", "opposite", "wrong", "chart", "prepared", "pretty", "solution", "fresh", "shop", "suffix", "especially", "shoes", "actually", "nose", "afraid", "dead", "sugar", "adjective", "fig", "office", "huge", "gun", "similar", "death", "score", "forward", "stretched", "experience", "rose", "allow", "fear", "workers", "Washington", "Greek", "women", "bought", "led", "march", "northern", "create", "British", "difficult", "match", "win", "doesn't", "steel", "total", "deal", "determine", "evening", "hoe", "rope", "cotton", "apple", "details", "entire", "corn", "substances", "smell", "tools", "conditions", "cows", "track", "arrived", "located", "sir", "seat", "division", "effect", "underline", "view"],
		],
		Length: [
			["a", "I"],
			["it", "my", "no", "do", "go", "of", "so", "on", "to", "an", "he", "or", "by", "as", "we", "at", "be", "is", "in", "me", "up", "us", "if", "am"],
			["ran", "the", "its",  "see", "saw", "was", "got",  "did", "nor", "she", "not", "ago",  "now", "all", "let", "off", "had", "has", "one", "too", "and", "any", "but", "her", "him", "our", "can", "how", "out", "for", "his", "may", "put", "get", "why", "run", "are", "you", "yet", "who"],
			["more",  "most", "much", "runs",  "just", "same", "them", "last", "then", "seen", "none", "sees",  "were", "they",  "does", "goes", "left",  "been", "less", "this", "done", "gone",  "gone", "have", "lets",   "some", "like", "onto", "each", "with", "gets", "into", "mine",  "your", "that", "puts", "than", "from", "many", "over", "also",  "full", "down", "else", "took", "when",  "came", "ever", "hers", "make", "what", "back", "come", "soon", "even", "upon", "such", "here", "made", "sure", "very",   "ours", "take",  "will",  "away"],
			["about", "above", "actor", "admit", "adopt", "adult", "after", "again", "agent", "agree", "ahead", "alarm", "alert", "alive", "allow", "alone", "along", "among", "anger", "angle", "apple", "arena", "argue", "array", "aside", "audio", "avoid", "award", "baker", "basic", "basis", "beach", "began", "begin", "being", "below", "bench", "birth", "black", "blind", "block", "board", "boost", "booth", "bound", "brain", "brand", "bread", "break", "bring", "brown", "build", "built", "buyer", "cable", "carry", "catch", "cause", "chain", "chair", "chart", "cheap", "check", "chest", "child", "chose", "civil", "claim", "class", "clean", "clear", "click", "clock", "close", "coach", "coast", "could", "count", "court", "cover", "craft", "crash", "crime", "cross", "crown", "cycle", "daily", "dance", "dated", "dealt", "delay", "depth", "doing", "doubt", "dozen", "draft", "drama", "dream", "dress", "drill", "drink", "drive", "drove", "eager", "early", "elite", "empty", "enjoy", "enter", "equal", "error", "event", "every", "exist", "extra", "false", "fault", "fiber", "fight", "final", "flash", "fleet", "floor", "fluid", "focus", "force", "found", "frame", "fraud", "fresh", "front", "fruit", "funny", "giant", "given", "glass", "globe", "going", "grade", "grand", "grass", "great", "green", "group", "guard", "guess", "guest", "guide", "happy", "heart", "heavy", "horse", "hotel", "house", "human", "ideal", "image", "input", "issue", "joint", "judge", "known", "label", "large", "laser", "later", "laugh", "learn", "lease", "least", "leave", "legal", "level", "light", "limit", "lives", "local", "logic", "loose", "lucky", "lunch", "lying", "magic", "march", "match", "maybe", "media", "metal", "might", "minor", "minus", "mixed", "model", "money", "motor", "mouse", "mouth", "movie", "music", "needs", "never", "night", "noise", "noted", "nurse", "occur", "ocean", "offer", "often", "order", "other", "paint", "paper", "party", "peace", "phone", "photo", "piece", "pilot", "pitch", "place", "plane", "plant", "plate", "point", "pound", "power", "press", "price", "pride", "print", "prize", "proof", "queen", "quick", "quiet", "radio", "raise", "range", "ratio", "reach", "ready", "right", "rival", "river", "robin", "rough", "round", "route", "royal", "scale", "scene", "score", "sense", "serve", "shall", "shape", "share", "sharp", "sheet", "shelf", "shell", "shift", "shirt", "shock", "shoot", "short", "sight", "since", "skill", "sleep", "slide", "small", "smart", "smile", "smoke", "solid", "solve", "sound", "space", "spare", "speak", "speed", "spend", "split", "spoke", "sport", "staff", "stage", "stand", "start", "state", "steam", "steel", "stick", "still", "stock", "stone", "story", "study", "stuff", "style", "sugar", "super", "sweet", "table", "taste", "teach", "teeth", "theft", "their", "theme", "there", "these", "thick", "thing", "think", "those", "throw", "tight", "times", "title", "today", "topic", "total", "touch", "tough", "tower", "trade", "train", "treat", "trial", "trend", "truck", "trust", "truth", "twice", "under", "union", "until", "upset", "value", "video", "visit", "vital", "voice", "waste", "watch", "water", "wheel", "where", "which", "while", "white", "whole", "woman", "women", "world", "would", "write", "wrong", "wrote", "yield", "young", "youth"],
			["accept", "access", "across", "acting", "action", "active", "afraid", "almost", "always", "amount", "animal", "answer", "anyone", "around", "artist", "assume", "attack", "author", "battle", "beauty", "became", "before", "behind", "belief", "better", "beyond", "border", "bottle", "bottom", "bought", "branch", "bridge", "bright", "broken", "budget", "button", "camera", "cannot", "career", "castle", "caught", "center", "chance", "change", "charge", "choice", "choose", "church", "circle", "client", "closed", "coffee", "combat", "coming", "common", "copper", "corner", "couple", "course", "create", "custom", "damage", "danger", "debate", "decade", "decide", "defeat", "defend", "define", "degree", "desert", "design", "desire", "detail", "device", "dinner", "doctor", "double", "driver", "during", "eating", "editor", "effect", "effort", "either", "empire", "enable", "ending", "energy", "engine", "enough", "entity", "escape", "except", "expand", "expert", "export", "fabric", "failed", "fallen", "family", "famous", "father", "fellow", "female", "figure", "finger", "finish", "flight", "flying", "follow", "forest", "forget", "formal", "friend", "future", "garden", "gather", "global", "golden", "ground", "growth", "guilty", "handle", "health", "height", "hidden", "honest", "impact", "import", "income", "indeed", "injury", "inside", "invest", "island", "junior", "killed", "launch", "lawyer", "leader", "leaves", "length", "lesson", "letter", "lights", "liquid", "listen", "little", "living", "losing", "luxury", "making", "manage", "manual", "margin", "marked", "market", "master", "mature", "medium", "member", "memory", "mental", "method", "middle", "mining", "minute", "mirror", "mobile", "modern", "moment", "mostly", "mother", "motion", "moving", "murder", "mutual", "myself", "narrow", "nation", "native", "nature", "nearby", "nights", "nobody", "normal", "number", "object", "office", "offset", "online", "option", "orange", "origin", "output", "packed", "palace", "parent", "person", "phrase", "picked", "planet", "player", "please", "pocket", "prince", "prison", "profit", "public", "raised", "random", "rarely", "rather", "rating", "reader", "really", "reason", "recent", "record", "reduce", "region", "remain", "remote", "remove", "repair", "repeat", "replay", "report", "rescue", "resort", "result", "retain", "return", "reveal", "reward", "riding", "rising", "ruling", "safety", "salary", "sample", "saving", "saying", "school", "screen", "search", "season", "secret", "secure", "select", "seller", "senior", "series", "server", "should", "signal", "signed", "silent", "silver", "simple", "single", "sister", "smooth", "social", "source", "speech", "spirit", "spring", "square", "stable", "status", "stolen", "stream", "street", "stress", "strike", "string", "strong", "studio", "submit", "sudden", "summer", "supply", "switch", "symbol", "system", "taking", "target", "tennis", "theory", "though", "threat", "ticket", "timing", "travel", "trying", "unique", "united", "unless", "update", "useful", "valley", "vendor", "vision", "visual", "volume", "walker", "wealth", "weekly", "weight", "window", "winner", "winter", "wonder", "worker", "writer", "yellow"],
			["ability", "absence", "academy", "account","accused","achieve", "acquire", "address", "advance", "adviser", "against", "airline", "alcohol", "already","ancient", "another", "anybody","article","attempt","average","balance","barrier","battery","because","bedroom","believe","besides","between","binding","brother","brought","burning", "cabinet", "calling", "capital", "captain", "caption", "capture", "careful", "caution", "ceiling", "central", "century", "certain", "channel", "chapter", "checked", "chicken", "circuit", "classes", "classic", "climate", "closing", "clothes", "collect", "college", "combine", "command", "comment", "company", "complex", "connect", "contact",  "contain", "content", "control", "correct", "country", "crystal", "culture", "decided", "default", "deliver", "desktop", "destroy", "diamond", "digital", "discuss", "disease", "display", "distant", "divided", "drawing", "driving", "economy", "edition", "elderly", "element", "evening", "exactly", "examine", "example", "exhibit", "explain", "explore", "express", "factory", "failing", "failure", "fashion", "feeling", "fiction", "finance", "finding", "fishing", "fitness", "forever", "fortune", "forward", "freedom", "further", "gallery", "gateway", "general", "genetic", "greater", "hanging", "healthy", "hearing", "helpful", "helping", "herself", "highway", "himself", "history", "holding", "holiday", "housing", "however", "husband", "illegal", "imagine", "improve", "include", "initial", "insight", "install", "instant", "instead", "intense", "involve", "journal", "journey", "justice", "justify", "keeping", "killing", "kingdom", "kitchen", "knowing", "landing", "lasting", "leading", "liberty", "library", "license", "limited", "logical", "loyalty", "machine", "manager", "married", "massive", "manager", "married", "maximum", "meaning", "measure", "medical", "meeting", "message", "mineral", "missing", "mission", "mistake", "morning", "musical", "mystery", "natural", "neither", "network", "nothing", "nuclear", "nursing", "obvious", "officer", "ongoing", "opening", "opinion", "outdoor", "outside", "package", "painted", "partial", "partner", "passing", "passion", "passive", "patient", "pattern", "payment", "perform", "picking", "picture", "plastic", "pointed", "popular", "precise", "prepare", "present", "primary", "printer", "private", "problem", "process", "produce", "program", "project", "promise", "protect", "provide", "publish", "purpose", "pushing", "quality", "quarter", "railway", "reading", "reality", "receive", "recover", "reflect", "regular", "release", "removal", "replace", "require", "resolve", "respect", "restore", "reverse", "routine", "running", "satisfy", "science", "section", "serious", "service", "setting", "shortly", "showing", "silence", "similar", "sitting", "skilled", "smoking", "someone", "speaker", "special", "station", "storage", "strange", "stretch", "student", "subject", "succeed", "success", "suggest", "summary", "support", "surface", "survive", "suspect", "teacher", "telling", "thought", "through", "tonight", "totally", "touched", "traffic", "trouble", "turning", "uniform", "unknown", "upgrade", "utility", "variety", "various", "vehicle", "venture", "version", "victory", "village", "virtual", "visible", "waiting", "walking", "warning", "weather", "website", "wedding", "weekend", "welcome", "whether", "winning", "without", "working", "writing", "written"],
			["absolute", "abstract", "academic", "accepted", "accident", "accuracy", "accurate", "achieved", "acquired", "activity", "actually", "addition", "adequate", "adjacent", "advanced", "advisory", "advocate", "affected", "aircraft", "alliance", "although", "aluminum", "analysis", "announce", "anything", "anywhere", "apparent", "appendix", "approach", "approval", "argument", "artistic", "assembly", "assuming", "athletic", "attached", "attitude", "attorney", "audience", "bacteria", "baseball", "bathroom", "becoming", "birthday", "boundary", "breaking", "building", "business", "calendar", "capacity", "catching", "category", "cautious", "cellular", "ceremony", "champion", "chemical", "children", "circular", "civilian", "clearing", "clothing", "collapse", "colorful", "commerce", "complain", "complete", "composed", "compound", "computer", "conclude", "concrete", "conflict", "confused", "consider", "constant", "continue", "contract", "contrary", "contrast", "convince", "corridor", "coverage", "covering", "creation", "creative", "criminal", "critical", "crossing", "cultural", "currency", "customer", "database", "daughter", "daylight", "deadline", "decision", "decrease", "deferred", "definite", "delicate", "delivery", "describe", "designer", "detailed", "dialogue", "diameter", "directly", "director", "disaster", "disclose", "discount", "discover", "distance", "distinct", "district", "division", "document", "dominant", "dramatic", "dressing", "dropping", "duration", "dynamics", "earnings", "educated", "election", "electric", "eligible", "emphasis", "employee", "endeavor", "engaging", "engineer", "enormous", "entrance", "envelope", "equality", "equation", "estimate", "evaluate", "everyday", "everyone", "evidence", "exchange", "exercise", "explicit", "exposure", "extended", "external", "facility", "familiar", "featured", "feedback", "festival", "finished", "firewall", "flagship", "flexible", "floating", "football", "foothill", "forecast", "foremost", "fraction", "frequent", "friendly", "frontier", "function", "generate", "governor", "graduate", "graphics", "grateful", "guardian", "guidance", "handling", "hardware", "heritage", "highland", "historic", "homepage", "hospital", "humanity", "identify", "identify", "ideology", "imperial", "include", "increase", "indicate", "indirect", "informal", "initiate", "innocent", "inspired", "instance", "integral", "intended", "interact", "interest", "interior", "internal", "intimate", "invasion", "involved", "isolated", "judgment", "keyboard", "landlord", "language", "laughter", "learning", "leverage", "lifetime", "lighting", "likewise", "limiting", "location", "magazine", "magnetic", "maintain", "majority", "marriage", "material", "maturity", "maximize", "meantime", "measured", "medicine", "merchant", "midnight", "military", "minimize", "minority", "mobility", "moderate", "momentum", "monetary", "mortgage", "mountain", "mounting", "movement", "multiple", "national", "negative", "notebook", "observer", "occasion", "offering", "official", "offshore", "operator", "opponent", "opposite", "optional", "ordinary", "organize", "original", "overcome", "overview", "painting", "parallel", "parental", "patience", "peaceful", "periodic", "personal", "persuade", "physical", "pipeline", "platform", "pleasant", "pleasure", "portable", "portrait", "position", "positive", "possible", "powerful", "practice", "precious", "presence", "preserve", "pressing", "pressure", "previous", "printing", "priority", "probable", "probably", "profound", "progress", "property", "proposal", "protocol", "provided", "purchase", "quantity", "question", "rational", "reaction", "received", "receiver", "recovery", "regional", "register", "relation", "relative", "religion", "remember", "repeated", "reporter", "republic", "required", "research", "reserved", "resource", "response", "restrict", "revision", "romantic", "sampling", "schedule", "scrutiny", "security", "sensible", "sentence", "separate", "sequence", "shipping", "shortage", "shoulder", "simplify", "slightly", "software", "solution", "somebody", "speaking", "specific", "sporting", "standard", "standing", "strategy", "strength", "struggle", "stunning", "suitable", "superior", "surgical", "surprise", "survival", "sweeping", "swimming", "symbolic", "sympathy", "tactical", "tailored", "tangible", "taxpayer", "teaching", "tendency", "terminal", "terrible", "thinking", "together", "tomorrow", "touching", "tracking", "training", "triangle", "tropical", "ultimate", "umbrella", "universe", "unlikely", "valuable", "variable", "violence", "weakness", "weighted", "whatever", "whenever", "wildlife", "wireless", "workshop", "yourself"],
			["abilities", "admission", "advantage", "adventure", "afternoon", "agreement", "announced", "attention", "authority", "automatic", "available", "awareness", "basically", "batteries", "beautiful", "beginning", "breakfast", "brilliant", "buildings", "carefully", "celebrate", "certified", "challenge", "character", "childhood", "chocolate", "classroom", "collected", "community", "completed", "component", "condition", "confident", "confirmed", "connected", "consumers", "container", "correctly", "dangerous", "delicious", "delivered", "depending", "determine", "developer", "different", "difficult", "direction", "discovery", "diversity", "education", "effective", "efficient", "elsewhere", "emergency", "encourage", "equipment", "essential", "everybody", "excellent", "exclusive", "existence", "expansion", "fantastic", "following", "frequency", "furniture", "household", "immediate", "implement", "important", "infection", "interface", "interview", "introduce", "inventory", "knowledge", "landscape", "lifestyle", "literally", "marketing", "meanwhile", "naturally", "nutrition", "operation", "otherwise", "ownership", "personnel", "portfolio", "potential", "practical", "preparing", "presented", "principle", "procedure", "professor", "promotion", "recognize", "recommend", "reduction", "reporting", "represent", "searching", "secondary", "secretary", "selection", "sensitive", "signature", "situation", "something", "somewhere", "statement", "structure",  "technical", "technique", "temporary", "tradition", "transport", "treatment", "universal", "wonderful", "yesterday"],
			["absolutely", "additional", "affordable", "appearance", "appriciate", "assessment", "assistance", "atmosphere", "attractive", "background", "basketball", "businesses", "collection", "commercial", "commission", "commitment", "comparison", "compatible", "completion", "compliance", "conclusion", "conference", "confidence", "connection", "consistent", "containing", "continuous", "contribute", "controller", "convenient", "conversion", "curriculum", "definition", "department", "depression", "difference", "difficulty", "discussion", "electrical", "employment", "enterprise", "especially", "evaluation", "everything", "everywhere", "experience", "expression", "facilities", "foundation", "functional", "generation", "government", "historical", "importance", "impossible", "impressive", "incredible", "individual", "industrial", "initiative", "innovation", "innovative", "instrument", "investment", "leadership", "literature", "management", "medication", "membership", "originally", "particular", "percentage", "performing", "permission", "philosophy", "population", "prevention", "production", "protection", "reasonable", "relatively", "reputation", "resistance", "resolution", "restaurant", "retirement", "scientific", "specialist", "statistics", "successful", "sufficient", "technology", "television", "throughout", "tournament", "transition", "understand", "understood", "university", "vegetables", "volunteers"],
		],
		RandomOfLevel : function(lvl, count=1){
			const ret = [];
			for (var x = 0; x < count; x++){
				var word = "";
				do {
					word = this.Level[lvl-1][Math.floor(Math.random() * this.Level[lvl-1].length)];
				} while (ret.includes(word));
				ret.push(word);
			}
			return ret.length == 1 ? ret[0] : ret;
		},
		RandomOfLength : function(len, count=1){
			const ret = [];
			for (var x = 0; x < count; x++){
				var word = "";
				do {
					word =this.Length[len-1][Math.floor(Math.random() * this.Length[len-1].length)];
				} while (ret.includes(word));
				ret.push(word);
			}
			return ret.length == 1 ? ret[0] : ret;
		},
	}
};

export const RandomColorz = {
	RandomColorz: {
		Get : function(filter=null){
			const colors = ["red", "orange", "yellow", "green", "blue", "purple"];
			const filterdex = colors.indexOf(filter);
			
			if (filterdex > -1){
				const ret = (filterdex + MetaRandom.Dex(colors.length-2) + 1) % colors.length;
				return colors[ret];
			}else{
				return colors[MetaRandom.Dex(colors.length)];
			}
		}
	}
};

export const LegacyEmbed = {
	Start : function(){
		window.Meta.LegacyDo(window.Meta.get("LegacyEngine"));
	},
	EndGame : function(){
		window.Meta.LegacyEnd();
	},
}